import './_styles.scss';
import React from 'react';
import AboutUs from './_about';
import Subscribe from './_subscribe';

export default () => (
  <section className='Section-About-Us'>
    <div className="Section-Wrapper">

      <AboutUs/>

      <Subscribe/>

    </div>
  </section>
)
